/* eslint-disable class-methods-use-this */
/* eslint-disable no-const-assign */
// const raf = require('raf');
// import globals from '../helpers';

import Parallax from 'parallax-js';

let parallax = null;
const helpers = {
	propertyCache: {},
	camelCase(value) {
		return value.replace(/-+(.)?/g, (match, character) => {
			return character ? character.toUpperCase() : '';
		});
	},
	vendors: [null, ['-webkit-', 'webkit'],
		['-moz-', 'Moz'],
		['-o-', 'O'],
		['-ms-', 'ms'],
	],
	accelerate(element) {
		helpers.css(element, 'transform', 'translate3d(0,0,0) rotate(0.0001deg)');
		helpers.css(element, 'transform-style', 'preserve-3d');
		helpers.css(element, 'backface-visibility', 'hidden');
	},
	css(element, property, value) {
		let jsProperty = helpers.propertyCache[property];

		if (!jsProperty) {
			for (let i = 0, l = helpers.vendors.length; i < l; i++) {
				if (helpers.vendors[i] !== null) {
					jsProperty = helpers.camelCase(`${helpers.vendors[i][1]}-${property}`);
				} else {
					jsProperty = property;
				}

				if (element.style[jsProperty] !== undefined) {
					helpers.propertyCache[property] = jsProperty;

					break;
				}
			}
		}

		element.style[jsProperty] = value;
	},
};

function init() {
	if (parallax === null) {
		const gridScene = document.querySelector('.home');
		const parallaxParams = {
			relativeInput: true,
			pointerEvents: true,
			selector: ['.grid-item__parallax', '.grid__content'],
			calibrateX: true,
			calibrateY: true,
		};
		parallax = new Parallax(gridScene, parallaxParams);
	}
}

function destroyed() {
	if (parallax !== null) {
		parallax.destroy();
		parallax = null;
	}
}

function disabled() {
	if (parallax !== null) {
		parallax.disable();
	}
}

function enabled() {
	if (parallax !== null) {
		parallax.enable();
	}
}

export default {
	init,
	destroyed,
	enabled,
	disabled,
};
